import { isDateControl, rankWith } from "@jsonforms/core";

export default rankWith(4, isDateControl);
